<template>
  <el-form-item :label="label" :prop="formProp">
    <el-form-item :prop="formProp">
      <el-input
        v-model="zhcnValue"
        :maxlength="maxlength"
        :disabled="isDisabled"
        :placeholder="isDisabled ? '' : '请输入简体'"
        :validate-event="false"
      ></el-input>
    </el-form-item>
    <el-form-item :prop="formProp">
      <el-input
        v-model="zhhkValue"
        :maxlength="maxlength"
        :disabled="isDisabled"
        :placeholder="isDisabled ? '' : '請輸入繁體'"
        :validate-event="false"
      ></el-input>
    </el-form-item>
    <el-form-item :prop="formProp">
      <el-input
        v-model="enValue"
        :maxlength="maxlength"
        :disabled="isDisabled"
        :placeholder="isDisabled ? '' : 'Please enter English description'"
        :validate-event="false"
      ></el-input>
    </el-form-item>
  </el-form-item>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    zhcnValue: {
      get() {
        return this.zhcn;
      },
      set(val) {
        this.$emit("update:zhcn", val);
        this.$nextTick(() => {
          this.handleTriggerValidate();
        });
      },
    },
    zhhkValue: {
      get() {
        return this.zhhk;
      },
      set(val) {
        this.$emit("update:zhhk", val);
        this.$nextTick(() => {
          this.handleTriggerValidate();
        });
      },
    },
    enValue: {
      get() {
        return this.en;
      },
      set(val) {
        this.$emit("update:en", val);
        this.$nextTick(() => {
          this.handleTriggerValidate();
        });
      },
    },
  },
  props: {
    label: {
      default: "",
      type: String,
    },
    formProp: {
      default: "",
      type: String,
    },
    zhcn: null,
    zhhk: null,
    en: null,
    maxlength: {
      default: 100,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleTriggerValidate() {
      this.$emit("update-rules-key", [this.zhcn, this.zhhk, this.en]);
      this.$forceUpdate();
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
::v-deep .el-input__inner {
  width: 100%;
}

::v-deep .el-form-item {
  width: 100%;
}
</style>
